<template>
  <el-dialog
    title="删除确认"
    :visible.sync="dialogVisible"
    width="30%"
    @close="handleClose"
  >
    <div style="text-align: center; margin-bottom: 20px;">
      <p>确定删除费用标准？</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">点错了</el-button>
      <el-button type="primary" @click="handleConfirm">确认删除</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteHousekeepingFeeConfig } from '@/api/housekeeping/housekeepingFeeConfigApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'DeleteHousekeepingFeeConfig',
  data() {
    return {
      dialogVisible: false,
      currentRow: null
    }
  },
  methods: {
    open(row) {
      this.currentRow = row
      this.dialogVisible = true
    },
    handleClose() {
      this.currentRow = null
    },
    async handleConfirm() {
      try {
        const params = {
          ...this.currentRow,
          shopId: getShopId()
        }
        await deleteHousekeepingFeeConfig(params)
        this.$message.success('删除成功')
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        this.$message.error(error)
        console.error('删除失败:', error)
      }
    }
  }
}
</script>